import type { Product } from '../types';
import { getLocalizedText } from '../i18n/localization';

export type PricingUnit = 'PER_WEIGHT' | 'PER_UNIT';

export function getAvailableWeights(product: Product): number[] {
  return product.productWeights.map((entry) => entry.weight);
}

export function getDefaultWeight(product: Product): number {
  return product.productWeights[0]?.weight ?? 1;
}

export function getWeightPrice(product: Product, weight: number): number {
  return product.productWeights.find((entry) => entry.weight === weight)?.price ?? 0;
}

export function getWeightUnit(product: Product, weight: number, languageCode?: string): string {
  const entry = product.productWeights.find((candidate) => candidate.weight === weight);
  if (!entry) return 'g';

  return getLocalizedText(entry.unit, entry.unitTranslations, languageCode);
}

export function getWeightLabel(product: Product, weight: number, languageCode?: string): string {
  return `${weight} ${getWeightUnit(product, weight, languageCode)}`;
}

export function cartKey(productId: number, weight: number): string {
  return `${productId}-${weight}`;
}

export function parseCartKey(key: string): { productId: number; weight: number } | null {
  const [productIdRaw, weightRaw, ...rest] = key.split('-');
  if (!productIdRaw || !weightRaw || rest.length > 0) {
    return null;
  }

  const productId = Number.parseInt(productIdRaw, 10);
  const weight = Number.parseInt(weightRaw, 10);
  if (!Number.isInteger(productId) || productId <= 0 || !Number.isInteger(weight) || weight <= 0) {
    return null;
  }

  return { productId, weight };
}
